import { createContext, useContext, useState, useCallback } from 'react';

const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {
  const [signupTheme, setSignupTheme] = useState(null); // 'female' | null
  const setTheme = useCallback((value) => {
    setSignupTheme(value === 'female' ? 'female' : null);
  }, []);
  return (
    <ThemeContext.Provider value={{ signupTheme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) return { signupTheme: null, setTheme: () => {} };
  return ctx;
}
